import { useEffect, useState, useContext, useRef } from "react";
import interact from 'interactjs'
import { MinuteGraphicLine } from "./MinuteGraphicLine";
import { MinuteGraphicPie } from "./MinuteGraphicPie";
import { MinuteGraphicImage } from "./MinuteGraphicImage";
import Slider from "../Slider"
import { DivMinuteEnum, SelectTypeGridEnum } from "../../../utils/enums";
import { AudienceContext } from "../../../context/AudienceContext";
import { NetworkAlertContext } from '../../../context/NetworkAlertContext';
import { UiContext } from "../../../context/UiContext";

export function MinuteGraphic({
  heading,
  lastAudience,
  data,
  dataPie,
  heightPie,
  Indice,
  selectTypeGrid,
  divMinute,
  audience
}) {
  const { isMobile, hasShortHeightDetail} = useContext(UiContext);
  const { doAudienceImageEmissora } = useContext(AudienceContext);
  const { setShowInfo } = useContext(NetworkAlertContext);
  const [isDragging, setIsDragging] = useState(false);
  const [scrollValue, setScrollValue] = useState(0);

  const divTableMinuteLeftRef = useRef<HTMLElement | null>(null);
  const divTableMinuteRightRef = useRef<HTMLElement | null>(null);
  const sliderHandleElementRef = useRef<HTMLElement | null>(null);
  const sliderEnabledRegionRef = useRef<HTMLElement | null>(null);
  const sliderElementRef = useRef<HTMLElement | null>(null);
  const rootComponentRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    rootComponentRef.current = document.getElementById("root");
  }, []);

  useEffect(() => {
    divTableMinuteLeftRef.current = document.getElementById('divTableMinuteLeft');
    divTableMinuteRightRef.current = document.getElementById('divTableMinuteRight');
    sliderHandleElementRef.current = document.getElementById('table-slider-handle');
    sliderEnabledRegionRef.current = document.getElementById('slider-enabled-region');
    sliderElementRef.current = document.getElementById('table-slider');
  }, [selectTypeGrid, audience]);


  useEffect(() => {
    if (selectTypeGrid === SelectTypeGridEnum.Image)
      doAudienceImageEmissora();
    const divTableMinuteRight = divTableMinuteRightRef.current;
    if (divTableMinuteRight && selectTypeGrid === SelectTypeGridEnum.Image) {
      divTableMinuteRight.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (divTableMinuteRight) {
        divTableMinuteRight.removeEventListener('scroll', handleScroll);
      }
    };
  }, [selectTypeGrid]);


  useEffect(() => {
    const divTableMinuteLeft = divTableMinuteLeftRef.current;
    const divTableMinuteRight = divTableMinuteRightRef.current;

    if (!isDragging && divTableMinuteRight && divTableMinuteLeft && divTableMinuteRight.scrollTop !== divTableMinuteLeft.scrollTop) {
      divTableMinuteLeft.scrollTop = divTableMinuteRight.scrollTop;
    }
  }, [scrollValue]);

  useEffect(() => {
    const sliderHandle = sliderHandleElementRef.current;
    const sliderEnabledRegion = sliderEnabledRegionRef.current;
    const sliderElement = sliderElementRef.current;
    const divTableMinuteRight = divTableMinuteRightRef.current;
    const divTableMinuteLeft = divTableMinuteLeftRef.current;
    const root = rootComponentRef.current;
    if (!sliderHandle || !sliderEnabledRegion || !sliderElement || !divTableMinuteRight || !divTableMinuteLeft || !root) return;

    sliderHandle.style.opacity = '1';
    sliderHandle.style.touchAction = 'none';
    sliderHandle.style.zIndex = '10';
    const preventTouch = (e) => e.preventDefault();
    sliderHandle.addEventListener('touchstart', preventTouch, { passive: false });


    let sliderWidth = sliderEnabledRegion.offsetWidth;
    let rightTable = divTableMinuteRight;
    let tablePositionPercent = (rightTable.scrollTop) / (rightTable.scrollHeight);

    let sliderPositionPercent = Math.sqrt(tablePositionPercent);
    let percent = 1 - sliderPositionPercent;
    let tablePercentLimit = (rightTable.scrollHeight - rightTable.clientHeight) / rightTable.scrollHeight;
    let sliderPercentLimit = Math.sqrt(tablePercentLimit);
    let unreachableSliderRegionWidth = sliderWidth * (1 - sliderPercentLimit);
    let xMin = 30 + unreachableSliderRegionWidth;
    let xMax = 30 + sliderWidth;
    let x0 = 30 + percent * (sliderWidth);
    sliderHandle.style.webkitTransform = sliderHandle.style.transform = 'translate(' + x0 + 'px, 0px)';
    sliderHandle.setAttribute('data-x', x0.toString());


    interact('.handle', { context: sliderElement })
      .draggable({
        max: Infinity,
        inertia: false,
        listeners: {
          move: function (event) {
            setIsDragging(true);
            let target = event.target as HTMLElement,
              x = (parseFloat(target.getAttribute('data-x') || '0')) + event.dx,
              limitedX = Math.max(xMin, Math.min(xMax, x)),
              scrollPercent = 1 - ((limitedX - 30) / sliderWidth);
            target.style.webkitTransform = target.style.transform = 'translate(' + limitedX + 'px, 0px)';
            if (divTableMinuteRight && selectTypeGrid == SelectTypeGridEnum.Image) {
              let newScrollValue = Math.pow(scrollPercent, 2) * rightTable.scrollHeight;
              divTableMinuteRight.scrollTop = newScrollValue;
            }
            target.setAttribute('data-x', limitedX.toString());
          },
          end: function () {
            setIsDragging(false);
          }
        }

      });
    return () => {
      sliderHandle.removeEventListener('touchstart', preventTouch);
    };
  }, [isDragging, selectTypeGrid, audience]);

  useEffect(() => {
    const sliderHandle = sliderHandleElementRef.current;
    const sliderEnabledRegion = sliderEnabledRegionRef.current;
    const divTableMinuteRight = divTableMinuteRightRef.current;
    if (!sliderHandle || !sliderEnabledRegion || !divTableMinuteRight) return;

    let sliderWidth = sliderEnabledRegion.offsetWidth;
    let scrollHeight = divTableMinuteRight.scrollHeight;
    let tablePositionPercent = (divTableMinuteRight.scrollTop) / (scrollHeight);
    let sliderPositionPercent = Math.sqrt(tablePositionPercent);
    let percent = 1 - sliderPositionPercent;
    let x0 = 30 + percent * (sliderWidth);
    sliderHandle.style.webkitTransform = sliderHandle.style.transform = 'translate(' + x0 + 'px, 0px)';
    sliderHandle.setAttribute('data-x', x0.toString());
  }, [scrollValue]);


  let scrollTimeout: NodeJS.Timeout | undefined;
  function handleScroll() {
    if (scrollTimeout) hideShowInfo();
    scrollTimeout = setTimeout(() => {
      const divTableMinuteRight = divTableMinuteRightRef.current;
      if (divTableMinuteRight) setScrollValue(divTableMinuteRight.scrollTop || 0);
    }, 150);
  }

  function hideShowInfo() {
    setTimeout(() => setShowInfo(false), 3000);
  }

  const contentGraphic = renderContentGraphic(Indice, divMinute, heading, lastAudience, data, dataPie, heightPie);
  const RootWidth = rootComponentRef.current ? parseFloat(getComputedStyle(rootComponentRef.current).width) : 0;
  const contentGraphicImage = renderContentGraphicImage(audience, heading, RootWidth, {
    sliderHandleElementRef,
    sliderEnabledRegionRef,
    sliderElementRef,
  }, isMobile, hasShortHeightDetail);

  return (
    <div
      id="minuteGraphic"
      data-testid="minuteGraphic"
      style={{ display: "block" }} >
      {selectTypeGrid === 3 ? contentGraphicImage : contentGraphic}
    </div>
  );
}


const renderContentGraphic = (Indice, divMinute, heading, lastAudience, data, dataPie, heightPie) => {
  return (Indice === 0 || Indice === 3 || Indice === 4) && divMinute === DivMinuteEnum.Minute ? (
    <MinuteGraphicLine
      heading={heading}
      lastAudience={lastAudience}
      data={data}
      divMinute={divMinute}
    />
  ) : (
    <MinuteGraphicPie
      heading={heading}
      lastAudience={lastAudience}
      dataPie={dataPie}
      heightPie={heightPie}
    />
  );
};

const renderContentGraphicImage = (audience, heading, RootWidth, sliderRefs, isMobile, hasShortHeightDetail) => {
  return audience != null ? (
    <>
      <MinuteGraphicImage heading={heading} data={audience} />
      <div
        style={{
          backgroundColor: "#000",
          display: isMobile && hasShortHeightDetail ? 'none' : 'block'
        }}>
        <Slider tableWidth={RootWidth} {...sliderRefs} />
      </div>
    </>
  ) : null;
};

